import React from "react";
import { Facebook, Instagram, MapPin, Phone, Mail } from "lucide-react";
import { siteInfo } from "../../mock";
import { IMAGES } from "../../data/site";
import Logo from "./Logo";
import sbdkLogo from "../../data/images/smdk.png";
import "../../styles/sbdrk-logo-font.css";
const Footer = () => {
  return (
    <footer
      id="contact"
      className="bg-[#FBF8F1] text-[#4E5750] border-t border-[#B79A68]/20"
    >
      <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">
        {/* Left: Valet */}
        <div className="text-center">
          <p className="font-cinzel text-[#7D6A42] uppercase tracking-[0.2em] text-sm mb-5">
            Complimentary parking on site.
          </p>
          <div className="relative w-full max-w-[280px] mx-auto h-[180px] overflow-hidden border border-[#B79A68]/30">
            <img
              src={IMAGES.galleriaOffice}
              alt="Office building"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="flex items-center justify-center gap-4 mt-6">
            <a
              href={siteInfo.socials.facebook}
              aria-label="Facebook"
              className="w-8 h-8 rounded-full border border-[#B79A68]/50 flex items-center justify-center text-[#7D6A42] hover:bg-[#B79A68] hover:text-[#ffffff] transition-colors"
            >
              <Facebook size={13} />
            </a>
            <a
              href={siteInfo.socials.instagram}
              aria-label="Instagram"
              className="w-8 h-8 rounded-full border border-[#B79A68]/50 flex items-center justify-center text-[#7D6A42] hover:bg-[#B79A68] hover:text-[#ffffff] transition-colors"
            >
              <Instagram size={13} />
            </a>
            <a
              href={siteInfo.socials.google}
              aria-label="Google"
              className="w-8 h-8 rounded-full border border-[#B79A68]/50 flex items-center justify-center text-[#7D6A42] hover:bg-[#B79A68] hover:text-[#ffffff] transition-colors"
            >
              <MapPin size={13} />
            </a>
          </div>
        </div>

        {/* Center: Logo + Address */}
        <div className="text-center flex flex-col items-center">
          <Logo size="lg" />
          <div className="flex items-center gap-3 my-5">
            <span className="h-px w-12 bg-gradient-to-r from-transparent to-[#B79A68]" />
            <span className="w-1.5 h-1.5 rotate-45 bg-[#B79A68]" />
            <span className="h-px w-12 bg-gradient-to-l from-transparent to-[#B79A68]" />
          </div>
          <a
            href={siteInfo.mapUrl}
            target="_blank"
            rel="noreferrer"
            className="text-[#7D6A42] hover:text-[#5F4F30] transition-colors"
          >
            <p>{siteInfo.addressLine1}</p>
            <p>{siteInfo.addressLine2}</p>
          </a>
          <a
            href={`mailto:${siteInfo.email}`}
            className="mt-5 text-[#7D6A42] hover:text-[#5F4F30] transition-colors flex items-center gap-2"
          >
            <Mail size={14} className="text-[#7D6A42]" />
            {siteInfo.email}
          </a>
          <a
            href={`tel:${siteInfo.phoneRaw}`}
            className="mt-3 font-cinzel text-2xl gold-gradient-text tracking-wider flex items-center gap-2"
          >
            <Phone size={16} className="text-[#7D6A42]" />
            {siteInfo.phoneFormatted}
          </a>
        </div>

        {/* Right: Map */}
        <div className="text-center">
          <p className="font-cinzel text-[#7D6A42] uppercase tracking-[0.2em] text-sm mb-5">
            Located 10 minutes from the Miracle Mile
          </p>
          <a
            href={siteInfo.mapUrl}
            target="_blank"
            rel="noreferrer"
            className="block relative w-full max-w-[280px] mx-auto h-[180px] overflow-hidden border border-[#B79A68]/30 group"
          >
            <iframe
              title="Map"
              src={siteInfo.mapEmbedUrl}
              className="w-full h-full grayscale-[60%] group-hover:grayscale-0 transition-all"
              loading="lazy"
            />
          </a>
          <a
            href={siteInfo.mapUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 mt-4 text-[#7D6A42] hover:text-[#5F4F30] text-xs uppercase tracking-[0.3em] font-cinzel"
          >
            <MapPin size={14} /> Open in Maps
          </a>
        </div>
      </div>

      {/* SBDK Partnership */}
      <div className="border-t border-[#B79A68]/40 py-12">
        <div className="max-w-7xl mx-auto px-6 flex flex-col items-center gap-3">


          <a
            href="https://smilesbydoctork.com"
            target="_blank"
            rel="noopener noreferrer"
            className="sbdrk-logo-lockup"
          >
            <span className="sbdrk-logo-left">Smiles</span>
            <img src={IMAGES.logo} alt="Smiles by Doctor K" className="h-12 w-auto" />
            <span className="sbdrk-logo-right">by Dr.K</span>
          </a>

          {/* <div className="flex items-center gap-3 sm:gap-4">
            <span className="font-script text-[28px] leading-none text-white-light">
              Smiles
            </span>
            <a
              href="https://smilesbydoctork.com"
              target="_blank"
              onClick={() => window.scrollTo(0, 0)}
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img
                src={IMAGES.logo}
                alt="Smiles by Doctor K"
                className="h-12 w-auto"
              />
            </a>
            <span className="font-script text-[28px] leading-none text-white-light">
              by Dr.K
            </span>
          </div> */}

          <p className="text-[#7D6A42]">
            Two Locations. One Philosophy.Personalized Dentistry by Dr.K
          </p>
          <div className="flex items-center justify-center gap-8 mt-1">
            <a
              href="/"
              onClick={() => window.scrollTo(0, 0)}
              className="text-[#7D6A42]"
            >
              Galleria Dental (Manalapan, NJ)
            </a>
            <span className="h-px w-8 bg-[#B79A68]/50" />
            <a
              href="https://edentalspa.com/"
              target="_blank"
              className="text-[#7D6A42]"
            >
              Essential Dental (Roslyn Heights, NY)
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[#B79A68]">
        <div className="max-w-7xl mx-auto px-6 py-5 flex flex-col md:flex-row items-center justify-between gap-2 text-[11px] text-[#7D6A42]/60 uppercase tracking-widest">
          <p className="text-[#7D6A42]/70">
            © {new Date().getFullYear()} All rights reserved.
          </p>
          <p className="text-[#7D6A42]/70">Designed with care.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
